import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { GestorGuard } from './core/guards/gestor.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { LoginComponent } from './login/login.component';
import { TimesRedirectComponent } from './core/components/times-redirect/times-redirect.component';
import { PrimeiroAcessoComponent } from './primeiro-acesso/primeiro-acesso.component';
import { EsqueciSenhaComponent } from './esqueci-senha/esqueci-senha.component';
import { SemAcessoComponent } from './sem-acesso/sem-acesso.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'login-ui', redirectTo: 'login', pathMatch: 'full' },
  { path: 'primeiro-acesso', component: PrimeiroAcessoComponent },
  { path: 'esqueci-senha', component: EsqueciSenhaComponent },
  { path: 'sem-acesso', component: SemAcessoComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: 'home', component: DashboardComponent },

      // === ROTAS CANÔNICAS (novos paths) ===
      {
        path: 'pessoas',
        canActivate: [GestorGuard],
        loadChildren: () => import('./pages/pessoas/pessoas.module').then(m => m.PessoasModule)
      },
      {
        path: 'empresa',
        canActivate: [GestorGuard],
        loadChildren: () => import('./pages/empresa/empresa.module').then(m => m.EmpresaModule)
      },
      {
        path: 'relatorios',
        canActivate: [GestorGuard],
        loadChildren: () => import('./pages/relatorios/relatorios.module').then(m => m.RelatoriosModule)
      },
      {
        path: 'meu-painel',
        loadChildren: () => import('./pages/meu-painel/meu-painel.module').then(m => m.MeuPainelModule)
      },
      {
        path: 'meus-relatorios',
        loadChildren: () => import('./pages/meus-relatorios/meus-relatorios.module').then(m => m.MeusRelatoriosModule)
      },
      {
        path: 'configuracoes',
        loadChildren: () => import('./pages/configuracoes/configuracoes.module').then(m => m.ConfiguracoesModule)
      },

      // === REDIRECTS RETROCOMPATÍVEIS (rotas antigas → novas) ===
      // /colaboradores → /pessoas
      { path: 'colaboradores',              redirectTo: 'pessoas',              pathMatch: 'full' },
      { path: 'colaboradores/membro/:id',   redirectTo: 'pessoas/membro/:id',   pathMatch: 'full' },

      // /times → /pessoas
      { path: 'times',                      redirectTo: 'pessoas',              pathMatch: 'full' },
      { path: 'times/membro/:id',           redirectTo: 'pessoas/membro/:id',   pathMatch: 'full' },
      {
        // Redirect retrocompatível: /times/:timeId → /pessoas?time=:timeId (preservado via TimesRedirectComponent)
        path: 'times/:timeId',
        component: TimesRedirectComponent,
        canActivate: [AuthGuard]
      },

      // /organizacao → /empresa
      { path: 'organizacao',                  redirectTo: 'empresa',              pathMatch: 'full' },
      { path: 'organizacao/departamentos-times', redirectTo: 'empresa/departamentos-times', pathMatch: 'full' },
      { path: 'organizacao/cargos',           redirectTo: 'empresa/cargos',       pathMatch: 'full' },
      { path: 'organizacao/hierarquia',       redirectTo: 'empresa/organograma',  pathMatch: 'full' },

      // outras rotas legadas
      { path: 'gestao-hierarquia',            redirectTo: 'empresa/organograma',  pathMatch: 'full' },
      { path: 'configuracoes-portal',         redirectTo: 'empresa',              pathMatch: 'full' },
      { path: 'manual',                       redirectTo: 'home',                 pathMatch: 'full' },
      { path: 'perfil',                       redirectTo: 'configuracoes/perfil', pathMatch: 'full' },
    ]
  },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
